// extracted by mini-css-extract-plugin
module.exports = {"header":"index__header___3DPuj","trigger":"index__trigger___1rfxi","right":"index__right___scby4"};